module.exports = __webpack_public_path__ + "img/downimg_bg02.2bfaef72.png";